module.exports = __webpack_public_path__ + "static/media/tg4.be078220.jpg";